"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconList = void 0;
var iconList = exports.iconList = [[{
  icon: "icon-jiaoyujuguanli"
}, {
  icon: "icon-jiaoyujuliebiao"
}], [{
  icon: "icon-xuexiaoliebiao"
}, {
  icon: "icon-xiangmuguanli"
}], [{
  icon: "icon-xiangmuleixingguanli"
}, {
  icon: "icon-zhuanyedaleishezhi"
}], [{
  icon: "icon-zhuanjiaguanli"
}, {
  icon: "icon-zhuanjialiebiao"
}], [{
  icon: "icon-cansaizuopinguanli"
}, {
  icon: "icon-wangzhanshezhi"
}], [{
  icon: "icon-daohangguanli"
}, {
  icon: "icon-xinwenfenleiguanli"
}], [{
  icon: "icon-xinwenshezhi"
}, {
  icon: "icon-lunbotuguanli"
}], [{
  icon: "icon-youqinglianjieguanli"
}, {
  icon: "icon-gerenzhongxin"
}], [{
  icon: "icon-xiugaimima"
}, {
  icon: "icon-shezhi"
}], [{
  icon: "icon-shengfenguanli"
}, {
  icon: "icon-shengfenliebiao"
}], [{
  icon: "icon-caidanguanli"
}, {
  icon: "icon-logoguanli"
}], [{
  icon: "icon-caidanliebiao"
}, {
  icon: "icon-jiaoseguanli"
}], [{
  icon: "icon-jiaoseliebiao"
}, {
  icon: "icon-xuexiaoguanli"
}], [{
  icon: "icon-jiaoshiliebiao"
}, {
  icon: "icon-xiangmuliebiao"
}], [{
  icon: "icon-wodexiangmu"
}, {
  icon: "icon-xiangmuguanli1"
}], [{
  icon: "icon-zhuanjiadaleishezhi"
}, {
  icon: "icon-wodexiangmu1"
}], [{
  icon: "icon-xiangmuliebiao1"
}, {
  icon: "icon-zhuanjiaguanli1"
}], [{
  icon: "icon-xinwenshezhi1"
}, {
  icon: "icon-zhuanjialiebiao1"
}], [{
  icon: "icon-xinwenfenleiguanli1"
}]];